import { Component } from 'src/utils';
import newOrderImg from './../../../images/new-order.png';
import recentOrderImg from './../../../images/recent-order.png';
import favoriteImg from './../../../images/favorites.png';
import homeArrow from './../../../images/home-arrow.png';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import dscImg from './../../../images/DSC.png';
import subHeaderImg from './../../../images/banner-image.jpg';
import logo from './../../../images/logo-s.png';
import dscCard from './../../../images/WBU-DSC-card.jpg';
import template from './ca-warn.html';

@Component({
  controllerAs: 'caWarn',
  template
})

export default class caWarn {
  static $inject = [
    '$scope',
    '$state',
    '$location',
    '$ngRedux',
    'authService',
    'orderService',
    '$window',
    '$stateParams',
    'APP',
    '$anchorScroll'
  ];

  constructor($scope, $state, $location, $ngRedux, authService,$order, $window, APP, $stateParams, $anchorScroll) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.$state = $state;
    this.$location = $location;
    this.host = $location.host();
    this.authService = authService;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.$auth = authService;
    this.$order = $order;
    this.us_zone_2=7.99;
    this.can_zone_0=14.99;
    this.us_shipping_available_for=75;
    this.can_shipping_available_for = 99;
    
    this.APP = APP;
    var ctrl = this;
    this.authService.getUserProfile()
        .then(() => ctrl.authService.getStoreDetail(ctrl.profile.store.storeURLName));
    $anchorScroll.yOffset = 50;
    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      profile: state.auth.profile,
      store: state.auth.storeDetail
    };
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');
    }
  }

  isLoggedIn() {
    return this.$location.path().indexOf('auth') === -1 &&
      this.$state.current.name !== 'login' &&
      this.$state.current.name !== 'signup';
  }

  isMobileDevice() {
    return this.$auth.isMobileLandscapeDevice();
  }
  
}



// WEBPACK FOOTER //
// ./src/app/dashboard/static/ca-warn.js